import React, { Component, Fragment } from "react"
import Field from "../../Common/Field/Field"

export default class TableRowSelect extends Component {
    state = {
        rowData: [],
        column: {},
        all: false
    }

    componentWillMount() {
        const { tableHeaderData, all } = this.props
        let { rowData } = this.props
        rowData = rowData.map(data => {
            let dat = { ...data }
            data.checkbox = false
            return dat
        })
        let column = { ...this.state.column }
        tableHeaderData.map(data => {
            column[data.tableKeyName] = true
        })

        this.setState({ rowData, tableHeaderData, column, all })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.rowData !== this.props.rowData) {
            const { tableHeaderData, all } = nextProps
            let { rowData } = nextProps
            rowData = rowData.map(data => {
                let dat = { ...data }
                data.checkbox = false
                return dat
            })
            let column = { ...this.state.column }
            tableHeaderData.map(data => {
                column[data.tableKeyName] = true
            })

            this.setState({ rowData, tableHeaderData, column, all })
        }
        // if (nextProps.selectedDate != '') {
        //     this.setState({ rowData: nextProps.rowData })
        // }
    }

    _handleCheckBox = (name, value, index) => {
        if (name === "all") {
            let rowData = [...this.state.rowData]
            rowData = rowData.map((data, index) => {
                data[`checkbox` + index] = true
                return data
            })
            this.setState({ rowData, [name]: value }, () =>
                this.props.getRowData(this.state)
            )
        } else {
            let rowData = [...this.state.rowData]
            rowData[index][name] = value

            this.setState({ rowData, all: false }, () =>
                this.props.getRowData(this.state)
            )
        }
    }

    _handleColumnCheckbox = (name, value) => {
        let column = { ...this.state.column }

        column[name] = value

        this.setState({ column }, () => this.props.getRowData(this.state))
    }

    render() {
        const { rowData, tableHeaderData, all, column } = this.state

        return (
            <div class="table-container table-responsive">
                <table class="striped table">
                    <thead>
                        <tr>
                            <th>
                                <p className="m-0 p-0">
                                    ALL
                                </p>
                                <Field
                                    isFormGroup={true}
                                    inputType="checkbox"
                                    inputName={"all"}
                                    value={all}
                                    onChange={this._handleCheckBox}
                                    className="mx-auto d-flex w-100 justify-content-center"
                                />
                            </th>
                            {tableHeaderData.length > 0 &&
                                tableHeaderData.map(data => {
                                    return (
                                        data.tableName !== "_id" && (
                                            <th>
                                                <p className="m-0 p-0">
                                                    {data.tableName}
                                                </p>
                                                <Field
                                                    isFormGroup={true}
                                                    inputType="checkbox"
                                                    inputName={data.tableKeyName}
                                                    value={column[data.tableKeyName]}
                                                    onChange={this._handleColumnCheckbox}
                                                    className="mx-auto d-flex w-100 justify-content-center"
                                                />
                                            </th>
                                        )
                                    )
                                })}
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.length > 0 &&
                            rowData.map((data, index) => {
                                return (
                                    <tr key={index}>
                                        <td key={data._id}>
                                            <Field
                                                isFormGroup={false}
                                                inputType="checkbox"
                                                inputName={`checkbox` + index}
                                                value={data[`checkbox${index}`]}
                                                index={index}
                                                onChange={this._handleCheckBox}
                                            />
                                        </td>
                                        {tableHeaderData.length > 0 &&
                                            tableHeaderData.map(keyName => {
                                                return (
                                                    keyName.tableKeyName !== "_id" && (
                                                        <td>
                                                            {data[keyName.tableKeyName] !== null &&
                                                                data[keyName.tableKeyName]}
                                                        </td>
                                                    )
                                                )
                                            })}
                                    </tr>
                                )
                            })}
                    </tbody>
                </table>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PrintFabricNo/TableRowSelect/index.js